/** @file Z-index ladder for consistent stacking context management. */

export const zIndex = {
  base: 0,
  sticky: 100,
  dropdown: 1000,
  overlay: 1300,
  drawer: 1400,
  modal: 1500,
  popover: 1600,
  toast: 1700,
  tooltip: 1800
};
